import React, {VoidFunctionComponent} from 'react';
import {FormattedMessage} from 'react-intl';

import StaticTextScreen from '../static-text-screen/static-text-screen';

const ImprintScreen: VoidFunctionComponent<Record<string, unknown>> = () => (
  <StaticTextScreen headlineId="imprint.headline">
    <FormattedMessage
      id="imprint.text"
      values={{
        p: (chunks: string) => <p>{chunks}</p>
      }}
    />
  </StaticTextScreen>
);

export default ImprintScreen;
